import { IGiaoVien } from "../../../model/respone/category/IGiaoVien";
import { IGiaoVienViewModel } from "../../../model/respone/category/IGiaoVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eGiaoVienActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IGiaoVienViewModel[],
  LOAD_ERRR: "",


  SHOW_EDIT_MODAL: {} as IGiaoVien | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IGiaoVien,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

};
export const eGiaoVienActionIds = generateActionTypeIds(
  eGiaoVienActionsObj,
  "GIAO_VIEN"
);
export type IGiaoVienActionTypes = IGenericActionType<
  typeof eGiaoVienActionsObj,
  "GIAO_VIEN"
>;
